<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Cadastro'" :novo="novo" :titulo="contentEdit.nomeEmpresa" :icone="icone" />
    <div class id="feedback-form" method="post">
      <div class="row">
        <div class="col-sm-2">
          <label for="">CNPJ: </label>
          <i for="">{{contentEdit.cnpj}} </i>
        </div>
        <div class="col-sm-4">
          <label for="">Nome da empresa: </label>
          <i for="">{{contentEdit.nomeEmpresa}} </i>
        </div>
        <div class="col-sm-12">
          <label for="">NR. Funcionários: </label>
          <i for="">{{contentEdit.numeroFuncionario}} </i>
        </div>
        <div class="col-sm-12"></div>
        <div class="col-sm-4">
          <label for="">Login: </label>
          <i for="">{{contentEdit.login}} </i>
        </div>
        <div class="col-sm-4">
          <label for="">E-mail: </label>
          <i for="">{{contentEdit.email}} </i>
        </div>
        <div class="col-sm-12"></div>
        <div class="col-sm-4">
          <label for="">Telefone celular: </label>
          <i for="">{{contentEdit.telefoneCelular}} </i>
        </div>
        <div class="col-sm-4">
          <label for="">Telefone fixo: </label>
          <i for="">{{contentEdit.telefoneFixo}} </i>
        </div>
        <div class="col-sm-12"></div>
        <div class="col-sm-12">
          <hr />
        </div>
        <div class="col-3 form-group">
          <small>Criado em:</small>
          <small v-if="contentEdit.tsInclusao">
            <b>{{formatData(contentEdit.tsInclusao)}}</b>
          </small>
        </div>
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Voltar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tbheader from "../_include/_headerTabelas";
import { getData,getError } from "../../global/utils";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: "",
      suporteAtivo: true,
      success: false,
      error:null,
      contentEdit: {
        titulo:'',
        ativo: false
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]

    };
  },
  components: { Tbheader  },
  methods: {
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnicone() {
      this.icone = "icon-eye-open";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: "/paineldegerenciamento/clientes"})
    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Visualizando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"/clientes/"+valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close()
    },   
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>